import Query from '../../components/Report';

const query = ({ offset = 0, domain = '' }) =>
    new Query('discover-recommendations-entity', { offset, domain });
export default query;
